import { render } from "./CompanyInfoView.vue?vue&type=template&id=2934dc8a&scoped=true"
import script from "./CompanyInfoView.vue?vue&type=script&lang=js"
export * from "./CompanyInfoView.vue?vue&type=script&lang=js"

import "./CompanyInfoView.vue?vue&type=style&index=0&id=2934dc8a&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2934dc8a"]])

export default __exports__